import { Component, HostBinding, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'drag-icon',
  templateUrl: 'drag-icon.component.html',
  styleUrls: ['drag-icon.component.scss'],
})
export class DragIconComponent {
  @HostBinding('class.drag-icon')
  defaultClass: boolean = true;

  @HostBinding('class.size-medium')
  @Input() sizeMedium: boolean = false;

  @Input() color: string = 'blue';
}
